import { createSelector } from 'reselect';

export const selectContactUsData = createSelector(
    (state) => state.app.contactUsData,
    (contactUsData) => contactUsData ? { ...contactUsData, processed: true } : null
);

export const selectHomePageData = createSelector(
    (state) => state.app.homePageData,
    (homePageData) => homePageData ? { ...homePageData, processed: true } : null
);

export const selectNavbarData = createSelector(
    (state) => state.app.navbarData,
    (navbarData) => navbarData ? { ...navbarData, processed: true } : null
);

export const selectAboutData = createSelector(
    (state) => state.app.aboutData,
    (aboutData) => aboutData ? { ...aboutData, processed: true } : null
);
export const selectEnterprisesData = createSelector(
    (state) => state.app.enterprisesData,
    (enterprisesData) => enterprisesData ? { ...enterprisesData, processed: true } : null
);

export const selectMetaData = createSelector(
    (state) => state.app.metaData,
    (metaData) => metaData ? { ...metaData, processed: true } : null
);
